import i18n from '@/i18n';
import { toast } from '@/hooks/useToast';

/**
 * Mirror of `notifyApiError` for the happy path. Hooks opt in by setting
 * `meta: { successMessage: 'success.toast.title.<key>' }` on `useMutation`;
 * the `MutationCache.onSuccess` handler in `query/client.ts` calls this with
 * the key and we render the green toast.
 *
 * Hooks without `successMessage` stay silent — some mutations (duplicate
 * checks, prefetches) shouldn't toast even when they succeed.
 */
export function notifyApiSuccess(messageKey: string): void {
  toast({
    variant: 'success',
    title: i18n.t(messageKey, { ns: 'common' }),
  });
}
